













































import { Vue, Component, Mixins } from "vue-property-decorator";

import MyList from "@/mixins/list";

import Add from "./tpl_add.vue";
import Edit from "./tpl_edit.vue";

@Component({
  components: {
    Add,
    Edit
  }
})
export default class extends Mixins(MyList) {
  dispatchType = "sms/tpllist";

  deleteConfirmContent = "确认要删除该模板吗？";

  dispatchTypeDelete = "sms/deletetpl";

  columns: any[] = [
    { title: "编号", dataIndex: "id" },
    { title: "名称", dataIndex: "tpl_name" },
    { title: "平台", scopedSlots: { customRender: "sms_platform" } },
    { title: "内容", scopedSlots: { customRender: "tpl_content" } },
    { title: "操作", scopedSlots: { customRender: "action" } }
  ];

  mounted() {
    this.loadData();
  }
}
